if ($('body').hasClass('template-product-family-rampart-fold')) {
    if ($(window).width() < 991) {
      $(document).on('click', 'a[href="#mini-case"]', function(e){
        e.preventDefault();
        $('.rampart-mini-case').fadeIn(300);
      });
      $(document).on('click', '.rampart-mini-case .popup-close, .rampart-mini-case .close-popup-overlay', function(e){
        e.preventDefault();
        $('.rampart-mini-case').fadeOut(300);
      });
    } else {
  $(document).on('click', 'body:not(.pdp-collection-hovered) a[href="#mini-case"], body:not(.pdp-collection-hovered) .rampart-gif a', function (event) {
      event.preventDefault();
                // On-page links
                if (location.pathname.replace(/^\//, "") == this.pathname.replace(/^\//, "") && location.hostname == this.hostname) {
                    // Figure out element to scroll to
                    var target = $(this.hash);
                    target = target.length ? target : $("[name=" + this.hash.slice(1) + "]");
                    // Does a scroll target exist?
                    if (target.length) {
                        // Only prevent default if animation is actually gonna happen
                        event.preventDefault();
                        $("html, body").animate(
                            {
                                scrollTop: target.offset().top - 100,
                            },
                            0600,
                            function () {
                                // Callback after animation
                                // Must change focus!
                                var $target = $(target);
                                $target.focus();
                                if ($target.is(":focus")) {
                                    // Checking if the target was focused
                                    return false;
                                } else {
                                    $target.attr("tabindex", "-1"); // Adding tabindex for elements not focusable
                                    $target.focus(); // Set focus again
                                }
                            }
                        );
                    }
                }
  });
    }
  } else {
  $(document).on('click', '.events--carousel a', function (event) {
                // On-page links
                if (location.pathname.replace(/^\//, "") == this.pathname.replace(/^\//, "") && location.hostname == this.hostname) {
                    // Figure out element to scroll to
                    var target = $(this.hash);
                    target = target.length ? target : $("[name=" + this.hash.slice(1) + "]");
                    // Does a scroll target exist?
                    if (target.length) {
                        // Only prevent default if animation is actually gonna happen
                        event.preventDefault();
                        $("html, body").animate(
                            {
                                scrollTop: target.offset().top - 100,
                            },
                            0600,
                            function () {
                                // Callback after animation
                                // Must change focus!
                                var $target = $(target);
                                $target.focus();
                                if ($target.is(":focus")) {
                                    // Checking if the target was focused
                                    return false;
                                } else {
                                    $target.attr("tabindex", "-1"); // Adding tabindex for elements not focusable
                                    $target.focus(); // Set focus again
                                }
                            }
                        );
                    }
                }
  });
  }